/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="walkinManagerSettings.base.section.ts" />

module Meevo.Plugins.WalkinManagerSettings {
    "use strict";

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    /**
     * Notifications Section of Walkin Manager Settings
     */
    export class NotificationsSection extends Meevo.Plugins.WalkinManagerSettings.BaseSection {

        private notificationKeys: Array<string> = [
            'notificationWelcomeText',
            'notificationPosition1Text',
            'notificationPositionXText',
            'notificationMissedText',
            'notificationClosingXText'
        ];

        /**
         * Handles retrieval of the item from the data service (if it hasn't already been loaded)
         * @returns {}
         */
        public activate(): void {
            this.availableMinuteValues = NotificationsSection.generateMinutesValues();
        }

        /**
         * Default handler on section edit cancellation
         * Reset text for all notification settings which are present on the page.
         * */
        public rollbackChanges (): void {
            this.notificationKeys.forEach((item) => {
                this.resetNotification(item);
            });
        }

        /**
         * Generate array of minute values for select
         * @returns {Array<number>} list of available values
         * */
        static generateMinutesValues (): Array<number> {
            let arr = [], value = 15;

            while (value < 181) {
                arr.push(value);
                value += 15;
            }

            return arr;
        }
    }

}